import React from 'react';
import RightArrow from '@/components/Icons/icons/RightArrow';
import moneyBagIcon from '@/images/icons/money-bag.svg';
import { PAYMENT_HISTORY_MODAL_QUERY_PARAM } from '@/utils/constants/paymentHistory';
import { timeAgo } from '@/utils/ts/stringUtils';
import { INotification, IProfile } from '@Saral-Influencer-Marketing/saral-utils/src/models';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import IconContainer from '../FtuxComponent/IconContainer';


interface AdSharePaymentSuccessNotificationProps {
  notification: INotification;
  setShowNotificationDropdown: (open: boolean | null) => void;
  markSingleNotificationAsSeen: () => void;
}

interface AdSharePayoutSucceededContent {
  body?: string;
}

export const AdSharePaymentSuccessNotification = ({
  notification,
  setShowNotificationDropdown,
  markSingleNotificationAsSeen,
}: AdSharePaymentSuccessNotificationProps) => {
  const influencerData = notification?.influencerId as unknown as IProfile;
  const content = (notification?.content ?? {}) as AdSharePayoutSucceededContent;
  const body = content.body?.trim() ?? '';

  const handleViewDetails = () => {
    const listId = influencerData?.lists?.[0];
    const profileId = influencerData?._id;

    if (listId && profileId) {
      window.open(
        `/dashboard/profile/${listId}/${profileId}?${PAYMENT_HISTORY_MODAL_QUERY_PARAM}=true`,
        '_blank',
        'noopener,noreferrer'
      );
    }

    markSingleNotificationAsSeen();
    setShowNotificationDropdown(null);
  };

  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <IconContainer icon="💰" bgColor="var(--background-default)" className="small" />
      </div>
      <div className="text-div">
        <h3 className="title">{notification?.title}</h3>
        {body && <p className="description">{body}</p>}
        <div className="mt-2">
          <ButtonComponent
            variant="text-highlight"
            className="p-0"
            onClick={handleViewDetails}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            <span className="text-sm">View Details</span>
          </ButtonComponent>
        </div>
        <p className="timestamp pt-2">{timeAgo(notification?.createdAt.toString())}</p>
      </div>
    </div>
  );
};

export default AdSharePaymentSuccessNotification;